
export const commonHeaders = {
    credentials: 'same-origin' as RequestCredentials,
    headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
    }
};
